import React, { FunctionComponent } from 'react'
import BasicRowItem from './BasicRowItem'
import { MultiSportRowItemProps } from '.'

const InformationRowItem: FunctionComponent<MultiSportRowItemProps> = ({
    display,
    children,
    width,
}) => (
    <BasicRowItem display={display} marginX={[2, 2, 3]} width={width}>
        {children}
    </BasicRowItem>
)

export default InformationRowItem
